import { useFeatureGates } from '@office-start/feature-gates-service';
import { useMemo } from 'react';
export var useStorageErrorDialogEnabled = function () {
    var featureGates = useFeatureGates().data;
    var storageErrorDialogEnabled = useMemo(function () {
        var _a, _b;
        return (((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.storageErrorGates) === null || _b === void 0 ? void 0 : _b.storageErrorDialogEnabled) || false);
    }, [featureGates]);
    return storageErrorDialogEnabled;
};
//# sourceMappingURL=useStorageErrorDialogEnabled.js.map